import {createAction} from "@reduxjs/toolkit";

import {teamMemberSlice} from "./teamMember.slice";

import type {FetchMemberTeamsPayload} from "./teamMember.types";

const {setMemberTeams, invalidateMemberTeams, resetMemberTeams} = teamMemberSlice.actions;

export enum ActionType {
    FETCH_MEMBER_TEAMS = "teamMember/fetchMemberTeamsSaga",
    INVALIDATE_AND_REFETCH_MEMBER_TEAMS = "teamMember/invalidateAndRefetchMemberTeams",
}

export const TeamMemberActions = {
    setMemberTeams,
    invalidateMemberTeams,
    resetMemberTeams,
    fetchMemberTeams: createAction<FetchMemberTeamsPayload>(
        ActionType.FETCH_MEMBER_TEAMS,
    ),
    invalidateAndRefetchMemberTeams: createAction<FetchMemberTeamsPayload>(
        ActionType.INVALIDATE_AND_REFETCH_MEMBER_TEAMS,
    ),
};
